import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetActiveSession } from 'domain/usecases';

export class RemoteGetActiveSession implements GetActiveSession {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetActiveSession.Result>,
  ) {}

  async execute(
    params: GetActiveSession.Params,
  ): Promise<GetActiveSession.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
